<template>
  <section id="about" class="bg-white min-h-screen">
    <div>
      <Title title="A propos" />

    </div>
    <div class="flex flex-col md:flex-row flex-wrap items-center justify-center md:mt-24 md:mx-16 md:gap-32 ">
      <div class="md:w-1/4 w-3/5 flex justify-center ">
        <div class="overflow-hidden rounded-lg">
          <img src="@/assets/emmaaa.jpg" class="transform scale-150" alt="">
        </div>
      </div>
      <div class="flex flex-col justify-center items-center md:w-1/2 px-5 md:px-0  text-center">
        <h1 class="md:text-4xl text-2xl font-bold mt-3 md:mt-0">Emma Nabyt</h1>
        <hr class="w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv" >
        <p v-if="isOther" class="text-justify ">
          Étudiante en 2ème année d'un bachelor communication marketing et publicité à l'ESP Paris. 
          Passionnée par l'univers de la communication, je m'intéresse autant à la stratégie des marques, aux réseaux sociaux,
           à la création de contenu, à l'événementiel... 
           <br>
           Ce qui m'anime c'est de pouvoir créer et partager des idées, des concepts, des projets.
          <br> Au-delà de mes études, j'aime la photographie, les voyages et le montage vidéo.
        </p>
        <p v-if="isMobile">
          Étudiante en 2ème année d'un bachelor communication marketing et publicité à l'ESP Paris. 
          Passionnée par l'univers de la communication, je m'intéresse autant à la stratégie des marques, aux réseaux sociaux,
           à la création de contenu, à l'événementiel... 
        </p>
        <br v-if="isMobile">
        <p v-if="isMobile">
          Ce qui m'anime c'est de pouvoir créer et partager des idées, des concepts, des projets.
          <br> Au-delà de mes études, j'aime la photographie, les voyages et le montage vidéo.
        </p>
    </div>
  </div>
      
  </section>
</template>

<script>
import Title from '@/components/title.vue'

export default {
  name: 'About',
  components: {
    Title
  },
  data() {
    return {
      isMobile: window.innerWidth <= 700,
      isOther: window.innerWidth > 700,
    }
  },
  mounted() {
        window.addEventListener("resize", this.checkScreenSize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkScreenSize);
    },
    checkScreenSize() {
            this.isMobile = window.innerWidth <= 700;
            this.isOther = window.innerWidth > 700;
        },
  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
